var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreCircleIconBold = function SvgMoreCircleIconBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.25 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m5.25 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m6 1.5c0 6.213-5.037 11.25-11.25 11.25S.75 18.213.75 12 5.787.75 12 .75A11.25 11.25 0 0 1 23.25 12m-1.5 0c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12s4.365 9.75 9.75 9.75A9.75 9.75 0 0 0 21.75 12",
    clipRule: "evenodd"
  })));
};
export default SvgMoreCircleIconBold;